import React, {
  Component
} from 'react';
const $=window.$;


export default class Ourservices extends Component {

 componentDidMount() {
   setTimeout(()=>{
    //Fancy Box
    $(".fancybox").fancybox({
     autoPlay : true, //  slideshow will start after opening the first gallery item
     playSpeed : 3000 // 3sec pause between changing next item
    });
    $('.fancybox-media')
    .attr('rel', 'media-gallery')
    .fancybox({
     openEffect : 'none',
     closeEffect : 'none',
     prevEffect : 'none',
     nextEffect : 'none',
     arrows : false,
     autoPlay : true,
     playSpeed : 3000,
     helpers : {
     media : {},
     buttons : {}
    }
    });

   },100);
 }

  render() {
    return (
     <section className="servies-pad">
     {/* video section */}
       <div className="row">
         <h1>Our Biggest driver is our passion</h1>
         <p>to explore, craft and delivery what our learners aspire to achieve.</p>
         <ul>
           <li>
             {/*<a className="fancybox-media" href="https://youtu.be/rsFjDOHH2uQ">*/}
             <a className="fancybox-media" href="https://www.youtube.com/embed/hursYeRv8qY?rel=0">
             <div className="video-img"><img src={process.env.PUBLIC_URL +'/images/video-img1.jpg'} alt="" />
               <div className="video-txt"><span className="blu-head">Craft and delivery</span></div>
             </div>
             <p>We enhance classroom learning with precise and realtime value adding knowledge <strong>Anytime. Anywhere. Any size learning.</strong></p>
             </a> </li>
           <li> <a className="fancybox-media" href="https://www.youtube.com/embed/aUGYpbidoVM?rel=0">
             <div className="video-img"><img src={process.env.PUBLIC_URL +'/images/video-img2.jpg'} alt="" />
               <div className="video-txt"><span className="gld-head">Our learners </span></div>
             </div>
             <p>We have a passion to automate, digitize and deliver high quality, engaging, learner-centered education solutions. We want to change the way the world LEARNS.</p>
             </a> </li>
           <li> <a className="fancybox-media" href="https://youtu.be/1QptxdRMMXA">
             <div className="video-img"><img src={process.env.PUBLIC_URL +'/images/video-img3.jpg'} alt="" />
               <div className="video-txt"><span className="vio-head">Aspire to achieve</span></div>
             </div>
             <p>Achieving large access, high excellence by combining modernity with maturity.</p>
             </a> </li>
         </ul>
       </div>
       {/* /video section */}
     </section>
    );
  }

}



// WEBPACK FOOTER //
// ./src/partials/Ourservices.js